import { useCallback, useEffect, useMemo, useState } from 'react'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'
import { apiPost } from '../../../generic/Api_Functions'
import { TextField } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import ConstructionIcon from '@mui/icons-material/Construction'
import createDialogTitle from '../../../generic/utilities/dialogUtil'
import AlertUI from '../../../generic/AlertUI'

const ResourceReportDialog = ({ open, setOpen, item, fabricationOrderId, nodeId, deviceId }) => {
  const { t_ } = useSmartTranslation()
  const [quantity, setQuantity] = useState(0)
  const [alert, showAlert, dismiss] = AlertUI()

  useEffect(() => {
    if (open) {
      dismiss()
      let newQuantity = item.quantity - item.reportedQuantity
      if (newQuantity < 1) {
        newQuantity = 1
      }
      setQuantity(newQuantity)
    }
  }, [item, open, dismiss])

  const onReportRawMaterial = useCallback(async () => {
    const quantityNumber = Number(quantity)

    if (isNaN(quantityNumber) || quantityNumber <= 0) {
      showAlert({
        title: '',
        severity: 'error',
        message: t_('Quantity must be a positive number')
      })
      return
    }
    try {
      await apiPost('partWorkflowHistory/rawMaterial/byFoAndNodeInstance/' + deviceId + '/' + fabricationOrderId + '/' + nodeId + '/' + item.resource.id + '/' + quantityNumber)
      setOpen(false)
    } catch (e) {
      showAlert({
        title: '',
        severity: e.name,
        message: e.message
      })
    }
  }, [fabricationOrderId, nodeId, deviceId, item, quantity, setOpen, showAlert, t_])

  const dialogRender = useMemo(() => {
    return (
      <>
        {alert}
        <h1>
          <TextField
            type='number'
            label={t_('Quantity')}
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            inputProps={{ step: 'any' }}
          />
        </h1>
      </>
    )
  }, [quantity, t_, alert])

  return (
    <SmartDialog
      setOpen={open}
      cancel
      cancelCallback={() => setOpen(false)}
      renderComponent={dialogRender}
      acceptCallback={onReportRawMaterial}
      title={createDialogTitle({ color: 'primary', title: t_('Report resource assembly'), icon: ConstructionIcon })}
    />
  )
}

export default ResourceReportDialog
